module.exports = " <div class=vc-range> <input type=range :step=step :min=min :max=max v-model=value> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/range.vue
 ** module id = 442
 ** module chunks = 1
 **/